/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Listening_WebsiteInputs */

const en_plan_listening_website = /** @type {(inputs: Plan_Listening_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening website`)
};

const es_plan_listening_website = /** @type {(inputs: Plan_Listening_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sitio web de Listening`)
};

/**
* | output |
* | --- |
* | "Listening website" |
*
* @param {Plan_Listening_WebsiteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_listening_website = /** @type {((inputs?: Plan_Listening_WebsiteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Listening_WebsiteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_listening_website(inputs)
	return en_plan_listening_website(inputs)
});